module.exports = __webpack_public_path__ + "static/media/logo_bilapp.4c1ff3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logo_bilapp.png
// module id = 162
// module chunks = 0